import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { Label } from "@cars24/turbo-web/lib/label";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { Heading } from "@cars24/turbo-web/lib/heading";
import { Button } from "@cars24/turbo-web/lib/button";
import LazyImage from "../../shared/lazy-image";
import { DisplayText } from "@cars24/turbo-web/lib/display-text";

const PreDeliveryInspectionEasySteps = ({
    details
}) => {
    const {
        subTitle: bannerSubTitle = "",
        title: bannerTitle = "",
        sectionData: bannerList = []
    } = details || {};

    const { tokens } = useTokens();

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    };

    return (
        <div styleName={"styles.stepsWrapper"}>
            <div styleName="styles.headerWrapper">
                <div>
                    <Heading level={2} isBold>{bannerTitle}</Heading>
                    <Label level={4} fontWeight="medium" color={tokens.text_default_text_secondary}>{bannerSubTitle}</Label>
                </div>
                <div>
                    <Button
                        label="Book inspection"
                        onClick={scrollToTop}
                        variant="primary"
                        size="large"
                    />
                </div>
            </div>
            <div styleName={"styles.cardWrapper"}>
                {
                    bannerList.length > 0 && bannerList.map((item, index) => {
                        return (
                            <div key={index} styleName={"styles.easyStepsTabWrapper"} id={"inspection-easy-steps"}>
                                <div styleName={"styles.easyTabImageWrapper"}>
                                    <LazyImage src={item.image.url} alt={item.title} />
                                    <DisplayText color={tokens.text_brand_text_brand} isBold>0{index + 1}</DisplayText>
                                </div>
                                <div styleName={"styles.easyStepsTabContent"}>
                                    <Label level={4} fontWeight="semibold" color={tokens.text_default_text_primary}>{item.title}</Label>
                                    <span>
                                        {item.description}
                                    </span>
                                </div>
                            </div>
                        );
                    })
                }
            </div>
        </div>
    );
};

PreDeliveryInspectionEasySteps.propTypes = {
    details: PropTypes.object
};

export default PreDeliveryInspectionEasySteps;
